import React from "react";
import { OptionCard } from "./OptionCard";

// Generic image-grid picker used for image_pick / font / texture / brand /
// shade — anything where each option is primarily a visual tile.
export const ImagePickField = ({ question, value, onChange, lang }) => {
  const allowMultiple = !!question.allow_multiple;
  const opts = question.options || [];
  if (!opts.length) return <div className="dq-empty">No options configured.</div>;
  const selected = allowMultiple
    ? Array.isArray(value) ? value : []
    : value;
  const isSel = (id) => (allowMultiple ? selected.includes(id) : selected === id);
  const toggle = (id) => {
    if (allowMultiple) {
      if (selected.includes(id)) onChange(selected.filter((x) => x !== id));
      else onChange([...selected, id]);
    } else {
      onChange(id);
    }
  };
  const qStyle = question.config && question.config.option_style;
  const useGrid = !qStyle || (qStyle !== "compact" && qStyle !== "icon");
  return (
    <div
      className={useGrid ? "dq-options" : ""}
      style={
        useGrid
          ? undefined
          : {
              display: "flex",
              flexWrap: "wrap",
              gap: 8,
              justifyContent: "center",
            }
      }
    >
      {opts.map((opt) => (
        <OptionCard
          key={opt.id}
          option={opt}
          selected={isSel(opt.id)}
          onClick={() => toggle(opt.id)}
          lang={lang}
          questionStyle={qStyle}
        />
      ))}
    </div>
  );
};
